import { breakpoints } from './breakpoints';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { palette } from './palette';
import { ReactNode } from 'react';
import { typography } from './typography';
import { zIndex } from './zIndex';

type Props = {
  children: ReactNode;
};

export default function ThemeProvider({ children }: Props) {
  const theme = createTheme({
    palette,
    typography,
    breakpoints,
    zIndex,
  });

  return <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>;
}
